import { IMenuItem } from './provider/IMenuItem'
import { vsName as menuServiceName, MenuService } from './provider/MenuService'

import { StateService } from '@uirouter/angularjs/lib-esm'

export class MenuController {
  static $inject: string[] = ['$state', menuServiceName]
  readonly $state: StateService
  readonly menuService: MenuService

  constructor($state: StateService, menuService: MenuService) {
    this.$state = $state
    this.menuService = menuService
  }

  getMenuItems(): IMenuItem[] {
    return this.menuService.getMenuItems()
  }

  isActive(menuItem: IMenuItem): boolean {
    return this.stateMatches(menuItem) && menuItem.getChildren().find(c => this.isActive(c)) === undefined
  }

  selfOrChildIsActive(menuItem: IMenuItem): boolean {
    const match = this.findMenuItemMatchingState(menuItem)
    return match !== undefined
  }

  stateIncludes(state: string): boolean {
    return this.$state.includes(state)
  }

  private findMenuItemMatchingState(menuItem: IMenuItem): IMenuItem | undefined {
    if (this.stateMatches(menuItem)) {
      return menuItem
    }

    return menuItem.getChildren().find(c => this.findMenuItemMatchingState(c))
  }

  private stateMatches(menuItem: IMenuItem): boolean {
    const state = menuItem.getState()
    const activeOnState = menuItem.getActiveOnState()
    const excludeActiveOnState = menuItem.getExcludeActiveOnState()

    const match = this.$state.includes(state) || this.$state.includes(activeOnState)
    if (!match) {
      return false
    }

    return !(excludeActiveOnState && this.$state.includes(excludeActiveOnState))
  }
}